<div class="container-fluid">
  <div class="row">
    <div class="col-12 px-0">
      <div class="card p-0 border-0 shadow-none">
        <div class="card-body p-3">
          <div class="d-flex flex-row flex-wrap justify-content-between mb-4">
            <div>
              <h1 class="card-title mb-1">Production Inventory</h1>
              <span class="sub-text">Manage labours and production inventory.</span>
            </div>

            @if (
              selectedTab !== ProductionTab.FACTORY_STOCK &&
              selectedTab !== ProductionTab.PRODUCT_TRANSFERS &&
              selectedTab !== ProductionTab.PRODUCTION_STOCK &&
              selectedTab !== ProductionTab.PRODUCTION_ENTRIES
            ) {
              <div class="mb-3 d-flex justify-content-end align-items-center">
                <ng-select
                  placeholder="All Warehouses"
                  [items]="rawMaterialWarehouse"
                  [formControl]="warehouseControl"
                  bindValue="id"
                  bindLabel="name"
                  [clearable]="true"
                  [searchable]="false"
                  style="min-width: 200px" />
              </div>
            }
          </div>

          <div class="tab-scroll-wrapper mb-4">
            <button
              class="tab-scroll-btn tab-scroll-btn--left"
              [class.tab-scroll-btn--visible]="canScrollLeft"
              (click)="scrollTabs(-1)"
              aria-label="Scroll tabs left">
              <i class="bi bi-chevron-left"></i>
            </button>
            <ul
              class="nav nav-pills flex-nowrap overflow-auto pb-1"
              role="tablist"
              style="white-space: nowrap"
              #tabNav
              (scroll)="onTabScroll()">
              @for (tab of tabs; track tab) {
                <li class="nav-item" role="presentation">
                  <button
                    class="nav-link"
                    [ngClass]="{ active: selectedTab === tab.value }"
                    (click)="selectTab(tab.value)">
                    <i [class]="tab.icon"></i>
                    <span class="ms-2">{{ tab.label }}</span>
                  </button>
                </li>
              }
            </ul>
            <button
              class="tab-scroll-btn tab-scroll-btn--right"
              [class.tab-scroll-btn--visible]="canScrollRight"
              (click)="scrollTabs(1)"
              aria-label="Scroll tabs right">
              <i class="bi bi-chevron-right"></i>
            </button>
          </div>

          @if (isInitialDataLoading) {
            <app-loading-spinner></app-loading-spinner>
          } @else {
            <ng-container [ngSwitch]="selectedTab">
              <ng-container *ngSwitchCase="ProductionTab.LABOURS">
                <app-labours [warehouseControl]="warehouseControl" [wareHouses]="rawMaterialWarehouse" />
              </ng-container>

              <ng-container *ngSwitchCase="ProductionTab.LABOURS_DAILY_ATTENDANCE">
                <app-labours-daily-attendance [warehouseControl]="warehouseControl" />
              </ng-container>

              <ng-container *ngSwitchCase="ProductionTab.PRODUCTION_ENTRIES">
                <app-production-entries [factoryList]="factories" />
              </ng-container>

              <ng-container *ngSwitchCase="ProductionTab.INVENTORY">
                <app-product-stock-list [warehouseControl]="warehouseControl" />
              </ng-container>

              <ng-container *ngSwitchCase="ProductionTab.FACTORY_STOCK">
                <app-factory-stock [factoryList]="factories" />
              </ng-container>

              <ng-container *ngSwitchCase="ProductionTab.PRODUCT_TRANSFERS">
                <app-product-transfer [factoryList]="factories" />
              </ng-container>

              <ng-container *ngSwitchCase="ProductionTab.PRODUCTION_STOCK">
                <app-production-stock />
              </ng-container>

              <ng-container *ngSwitchCase="ProductionTab.FACTORY_STOCK_ADJUSTMENTS">
                <app-product-stock-adjustments scope="factory" [factoryList]="factories" />
              </ng-container>

              <ng-container *ngSwitchCase="ProductionTab.WAREHOUSE_STOCK_ADJUSTMENTS">
                <app-product-stock-adjustments scope="warehouse" />
              </ng-container>
            </ng-container>
          }
        </div>
      </div>
    </div>
  </div>
</div>
